import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../app/store";
import { Paths } from "../router/Paths";
import { setHeaderShown } from "../reducer/uiReducer";
import CachedItem, { LoadCachedItem } from "../config/cache";
import { useLocation } from "react-router-dom";

export default function useRedirect() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { account } = useSelector((state: RootState) => state.account);
  const location = useLocation();

  const authenticationRedirect = () => {
    // const token = LoadCachedItem(CachedItem.token);
    const accessToken = localStorage.getItem("accessToken");
    const token = localStorage.getItem("token");
    if (location.pathname === Paths.home) return;
    if (accessToken || token) {
      loggedinRedirect();
      dispatch(setHeaderShown(true));
    } else {
      loginRedirect();
      dispatch(setHeaderShown(false));
    }
  };

  const loggedinRedirect = () => {
    const paths = [
      Paths.welcome,
      Paths.registration,
      Paths.paymentAndTax,
      Paths.verification,
      Paths.aifilter,
      Paths.tourManagementCreate,
      Paths.tourManagementPackageName,
      Paths.tourManagementPackageDescription,
      Paths.tourManagementPackageLocation,
      Paths.tourManagementPackageKeywords,
      Paths.tourManagementPackageInclusion,
      Paths.tourManagementPackageGuideInfo,
      Paths.tourManagementPackageFood,
      Paths.tourManagementPackageTransportation,
      Paths.tourManagementPackageExtraInfo,
      Paths.tourManagementPackagePhotoUpload,
      Paths.tourManagementPackageOptions,
      Paths.tourManagementPackageOptionsSetup,
      Paths.tourManagementPackageOptionsMeeting,
      Paths.tourManagementPackageOptionsConnectivity,
      Paths.tourManagementPackageOptionsAvailability,
      Paths.tourManagementPackageOptionsAvailabilitySchedule,
      Paths.tourManagementPackageOptionsAvailabilityPriceCategory,
      Paths.tourManagementPackageOptionsAvailabilityCapacity,
      Paths.tourManagementPackageOptionsAvailabilityPrice,
      Paths.tourManagementPackageOptionsAvailabilityAddOn,
      Paths.tourManagementPackageOptionsCutOff,
      Paths.tourManagementPackageOptionsCancelationPolicy,
      Paths.availablity,
      Paths.booking,
      Paths.specialOffers,
      Paths.finance,
      Paths.manageProduct,
      Paths.manageProductDetails,
      Paths.manageProductOptionsDetails,
      Paths.manageSpecialOffers,
      Paths.userType,
      Paths.privacyPolicy,
      Paths.createProtocol,
    ];
    if (paths.some((path) => location.pathname.startsWith(path))) {
      return;
    } else {
      navigate(Paths.welcome);
    }
  };

  const loginRedirect = () => {
    const paths = [
      Paths.login,
      Paths.signup,
      Paths.forgot,
      Paths.verifyEmail,
      Paths.recoverPassword,
      Paths.userType,
    ];
    if (paths.includes(location.pathname)) {
      return;
    } else {
      navigate(Paths.login);
    }
  };

  useEffect(() => {
    authenticationRedirect();
  }, [account, location]);

  return undefined;
}
